import { Mask } from '../../class/workflow.type';

import { CurrencyMaskProcessing } from './mask-processing/currency';
import { DateMaskProcessing } from './mask-processing/date';
import { DateShortMaskProcessing } from './mask-processing/date-short';
import { EinMaskProcessing } from './mask-processing/ein';
import { IntMaskProcessing } from './mask-processing/int';
import { NumberMaskProcessing } from './mask-processing/number';
import { PhoneMaskProcessing } from './mask-processing/phone';
import { PhoneExtMaskProcessing } from './mask-processing/phone-ext';
import { SsnMaskProcessing } from './mask-processing/ssn';
import { YearMaskProcessing } from './mask-processing/year';
import { ZipMaskProcessing } from './mask-processing/zip';
import { ZipExtMaskProcessing } from './mask-processing/zip-ext';

import { InputMaskProcessingBaseConstructor } from './input-mask-processing.base';
import { CurrencyWithDecimalsMaskProcessing } from './mask-processing/currency-with-decimals';
import { DummyMaskProcessing } from './mask-processing/dummy';
import { PercentMaskProcessing } from './mask-processing/percent';
import { PercentWithDecimalsMaskProcessing } from './mask-processing/percent-with-decimals';
import { PercentWithFixedDecimalsMaskProcessing } from './mask-processing/percent-with-fixed-decimals';

/**
 * Exactly one mask processing class for each and every item on `Mask` type
 */
export const maskRegistry: { [maskName in Required<Mask>]: InputMaskProcessingBaseConstructor } = {
  currency: CurrencyMaskProcessing,
  'currency-decimals': CurrencyWithDecimalsMaskProcessing,
  date: DateMaskProcessing,
  'date-short': DateShortMaskProcessing,
  decimal: NumberMaskProcessing,
  dummy: DummyMaskProcessing,
  ein: EinMaskProcessing,
  int: IntMaskProcessing,
  percent: PercentMaskProcessing,
  'percent-decimals': PercentWithDecimalsMaskProcessing,
  'percent-fix-decimals': PercentWithFixedDecimalsMaskProcessing,
  phone: PhoneMaskProcessing,
  'phone-ext': PhoneExtMaskProcessing,
  ssn: SsnMaskProcessing,
  year: YearMaskProcessing,
  zip: ZipMaskProcessing,
  'zip-ext': ZipExtMaskProcessing
};
